module.exports = __webpack_public_path__ + "school/img/fuwuqi1.29e11062.jpg";